import * as ActionTypes from '../actions/actionTypes';
import {INCIDENT_PRESCRIPTION_STATUS, INCIDENT_TYPE_KEYS} from '../Constants';
import {incidentPrescriptionsLayerIsActive} from '../utils/prescriptions_utils';
import {formatForGraph} from '../utils/time_utils';
import {getNextVersion} from './asyncManagerMiddleware';

let _currentRunKey = null;

const _populateBurnWeatherAsync = (dispatch, burn, time, runKey) => {
  // Removes all the data not related to time.
  const __clean = (data) => {
    const timeKey = formatForGraph(time);
    const cleanData = {};
    cleanData[timeKey] = data[timeKey];
    return cleanData;
  };

  return new Promise((resolve) => {
    const data = burn.prescriptionWeather;
    if (data) {
      dispatch({
        type: ActionTypes.POPULATE_BURN_PRESCRIPTION_WEATHER,
        data: __clean(data),
        burn,
        time,
        asyncVersion: runKey
      });
    }
    resolve();
  });
};

const _populateAllBurnWeatherAsync = (dispatch, incidents, time) => {
  const runKey = getNextVersion(ActionTypes.POPULATE_BURN_PRESCRIPTION_WEATHER);
  _currentRunKey = runKey;

  return new Promise((resolve, reject) => {
    const burns = [];
    incidents.layers.forEach(l => {
      if (l.active && l.id.startsWith('BURNS_')) {
        var layerBurns = incidents.data[l.id.toLowerCase()];
        if (layerBurns) {
          burns.push(...layerBurns.features.filter(
            b => b.prescriptionStatus === INCIDENT_PRESCRIPTION_STATUS.PRESCRIPTION_NOT_LOADED));
        }
      }
    });
    // Sort the burns from left to right for a more pretty render
    burns.sort((b1, b2) => b1.geometry.coordinates[0] - b2.geometry.coordinates[0]);

    // Collect at a list of indicators and times for which we need data.
    //const indicatorAndTimeList = collectIndicatorTimeList(indicators, time);

    // Do each burn sequentially to avoid killing the geoserver.
    const startPromise = Promise.resolve();
    const endPromise = burns.reduce((p, burn) => {
      return p.then(() => {
        // Detect if a new run has been started and give up on the old one.
        if (runKey === _currentRunKey) {
          return _populateBurnWeatherAsync(dispatch, burn, time, runKey);
        } else {
          return Promise.resolve();
        }
      });
    }, startPromise);
    endPromise.then(() => dispatch({ type: ActionTypes.REFRESH_BURN_PRESCRIPTIONS_COMPLETE }))
              .then(resolve())
              .catch(e => {reject(e);});
  });
};

export const orchestrateBurnPrescriptions = store => next => action => {
  // First complete the current action
  const result = next(action);

  const { incidents, time } = store.getState();
  const dispatch = store.dispatch;

  switch (action.type) {
    case ActionTypes.SET_ACTIVE_TIME:
      dispatch({ type: ActionTypes.CLEAR_AND_REFRESH_BURN_PRESCRIPTION_WEATHER });
      break;

    case ActionTypes.POPULATE_BURN_DETAILS:
      dispatch({ type: ActionTypes.REFRESH_BURN_PRESCRIPTION_WEATHER });
      break;

    case ActionTypes.TOGGLE_INCIDENT_TYPE:
      if (action.id === INCIDENT_TYPE_KEYS.INCIDENT_PRESCRIPTIONS) {
        if (incidentPrescriptionsLayerIsActive(incidents.layers)) {
          dispatch({ type: ActionTypes.REFRESH_BURN_PRESCRIPTION_WEATHER });
        } else {
          // If Prescriptions layer is turned off, kill any runs in progress
          _currentRunKey = null;
        }
      }
      break;

    case ActionTypes.POPULATE_BURN_PRESCRIPTIONS:
    case ActionTypes.CLEAR_AND_REFRESH_BURN_PRESCRIPTION_WEATHER:
    case ActionTypes.REFRESH_BURN_PRESCRIPTION_WEATHER:
      if (incidentPrescriptionsLayerIsActive(incidents.layers) && time.selected_time) {
        _populateAllBurnWeatherAsync(dispatch, incidents, time.selected_time);
      }
      break;

    default:
      break;
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/middleware/burnPrescriptionsMiddleware.js